export default __webpack_public_path__ + "static/5-15e9956005bec11113de3e3b8cb46bc8.png";